import { useWorkspace } from "@/components/providers/workspace-provider";
import { useSession } from "@/components/providers/session-provider";
import {
  Building2,
  ChevronDown,
  Globe2,
  GraduationCap,
  Heart,
  Users,
} from "lucide-react";

export function WorkspaceSwitcher() {
  const { me, isAdmin } = useSession();
  const {
    workspaces,
    loading,
    selectedWorkspaceId,
    setSelectedWorkspaceId,
  } = useWorkspace();

  if (!isAdmin && me?.workspaceAccessEnabled !== true) {
    return null;
  }

  if (loading && workspaces.length === 0) {
    return <div className="h-9 w-40 animate-pulse rounded-lg bg-surface-muted" />;
  }

  const selected = workspaces.find(
    (workspace) => workspace.id === selectedWorkspaceId,
  ) ?? (workspaces.length === 1 ? workspaces[0] : undefined);
  const Icon = {
    building: Building2,
    users: Users,
    heart: Heart,
    school: GraduationCap,
    globe: Globe2,
  }[selected?.typeIcon ?? "globe"] ?? Globe2;

  if (workspaces.length === 0) {
    return null;
  }

  const controlClasses =
    "flex h-8 max-w-56 items-center rounded-lg border border-border bg-surface text-xs font-semibold text-text";

  if (workspaces.length === 1) {
    return (
      <div className="hidden flex-col gap-0.5 lg:flex">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-text-muted">
          Workspace
        </span>
        <div className={`${controlClasses} gap-2 px-3`}>
          <Icon className="h-4 w-4 shrink-0 text-[var(--brand-primary)]" />
          <span className="truncate">{workspaces[0].name}</span>
        </div>
      </div>
    );
  }

  return (
    <label className="hidden flex-col gap-0.5 lg:flex">
      <span className="text-[10px] font-semibold uppercase tracking-wide text-text-muted">
        Workspace
      </span>
      <span className="relative">
        <Icon className="pointer-events-none absolute left-3 top-2 h-4 w-4 text-[var(--brand-primary)]" />
        <select
          value={selectedWorkspaceId ?? "all"}
          onChange={(event) =>
            setSelectedWorkspaceId(
              event.target.value === "all" ? null : event.target.value,
            )
          }
          className={`${controlClasses} appearance-none py-1 pl-9 pr-8 outline-none transition-colors hover:border-border-strong focus:border-[var(--brand-primary)]`}
        >
          <option value="all">All workspaces</option>
          {workspaces.map((workspace) => (
            <option key={workspace.id} value={workspace.id}>
              {workspace.name}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-2.5 top-2.5 h-3.5 w-3.5 text-text-muted" />
      </span>
    </label>
  );
}
